import NorthwestStraitsFoundationLogo from '../containers/ListingPage/Assets/Logo-NWStraits-1_500x230.webp';
import PugetSoundkeeperLogo from '../containers/ListingPage/Assets/logo-clear-with-drop-shadow.webp';
import FriendsSanJuansLogo from '../containers/ListingPage/Assets/Logo-Friends-of-the-San-Juans-1_502x126.webp';
import anacortesYachtClubFlag from '../assets/Yacht_Club_Flags/1-AnacortesYachtClub-burgee_sm_10.png';
import bellevueYachtClubFlag from '../assets/Yacht_Club_Flags/2-bellevue.gif';
import bellinghamYachtClubFlag from '../assets/Yacht_Club_Flags/3-bellingham.gif';
import birchBayVillageYachtClubFlag from '../assets/Yacht_Club_Flags/4-birchbayyc.gif';
import bremertonYachtClubFlag from '../assets/Yacht_Club_Flags/5-bremertonyc.gif';
import brownsvilleYachtClubFlag from '../assets/Yacht_Club_Flags/6-brownsvilleyc.gif';
import camanoIslandYachtClubFlag from '../assets/Yacht_Club_Flags/7-camanoislyc.gif';
import carlingYachtClubFlag from '../assets/Yacht_Club_Flags/8-CarlingYCGif.gif';
import corinthianYachtClubOfBellinghamFlag from '../assets/Yacht_Club_Flags/9-cycbellinghamgif.gif';
import corinthianYachtClubOfEdmondsFlag from '../assets/Yacht_Club_Flags/10-CYCEdmondsGif.gif';
import corinthianYachtClubOfSeattleFlag from '../assets/Yacht_Club_Flags/11-CYCSeattleGif.gif';
import corinthianYachtClubOfTacomaFlag from '../assets/Yacht_Club_Flags/12-CYCTacomaYCGif.gif';
import dagmarsYachtClubFlag from '../assets/Yacht_Club_Flags/13-DagmarsYCGif.gif';
import dayIslandYachtClubFlag from '../assets/Yacht_Club_Flags/14-DayIslandYCGif.gif';
import deerHarborYachtClubFlag from '../assets/Yacht_Club_Flags/15-dearharboryachtclub_616.png';
import desMoinesYachtClubFlag from '../assets/Yacht_Club_Flags/16-desmoinesyc.gif';
import duwamishYachtClubFlag from '../assets/Yacht_Club_Flags/17-DuwamishYCGif.gif';
import eagleHarborYachtClubFlag from '../assets/Yacht_Club_Flags/18-EagleHarborGif.gif';
import edmondsYachtClubFlag from '../assets/Yacht_Club_Flags/19-EdmondsYCGif.gif';
import emeraldRoseYachtClubFlag from '../assets/Yacht_Club_Flags/20-emeraldroseycsolidrose_21.png';
import everettYachtClubFlag from '../assets/Yacht_Club_Flags/21-EverettYC_burgeesiteimage__30.png';
import fidalgoYachtClubFlag from '../assets/Yacht_Club_Flags/22-FidalgoGif.gif';
import fircrestYachtClubFlag from '../assets/Yacht_Club_Flags/23-FirecrestYC_burgee_01_83.png';
import flounderBayYachtClubFlag from '../assets/Yacht_Club_Flags/24-FlounderBayYCGif.gif';
import foxIslandYachtClubFlag from '../assets/Yacht_Club_Flags/25-FoxIslandYC_new burgree2.jpg';
import gigHarborYachtClubFlag from '../assets/Yacht_Club_Flags/26-GifHarborYCGif.gif';
import hatIslandYachtGolfClubFlag from '../assets/Yacht_Club_Flags/27-HatIslandYCGif.gif';
import hiddenHarborYachtClubFlag from '../assets/Yacht_Club_Flags/28-HiddenHarborYCGif.gif';
import kingstonCoveYachtClubFlag from '../assets/Yacht_Club_Flags/29-KingstonCoveGif.gif';
import laConnerYachtClubFlag from '../assets/Yacht_Club_Flags/30-LaConnerYC-WA.png';
import lopezIslandYachtClubFlag from '../assets/Yacht_Club_Flags/31-lopezislandyc.gif';
import meydenbauerBayYachtClubFlag from '../assets/Yacht_Club_Flags/32-MeydenbaurBayYCGif.gif';
import milltownSailingAssociationFlag from '../assets/Yacht_Club_Flags/33-MilltowSailingAssn_msalogo22__33__33.gif';
import mukilteoYachtClubFlag from '../assets/Yacht_Club_Flags/34-MukilteoYachtClub_burgeesm__31.gif';
import navyYachtClubEverettFlag from '../assets/Yacht_Club_Flags/35-NavyYachtClub-Everett-eburgee__32.gif';
import oakHarborYachtClubFlag from '../assets/Yacht_Club_Flags/36-OakHarborGif.gif';
import olympiaYachtClubFlag from '../assets/Yacht_Club_Flags/37-OlympiaYCGif.gif';
import orcasIslandYachtClubFlag from '../assets/Yacht_Club_Flags/38-orcasislandyc.gif';
import oroBayYachtClubFlag from '../assets/Yacht_Club_Flags/39-OroBayYCGif.gif';
import pleasantHarborYachtClubFlag from '../assets/Yacht_Club_Flags/40-PleasantHarborYachtClub_phycburgee__39.png';
import pointRobertsMarinaResortFlag from '../assets/Yacht_Club_Flags/41-PointRobertsMarinaResort_burgee__20.png';
import pointRobertsYachtClubFlag from '../assets/Yacht_Club_Flags/42-PointRobertsYC_burgee__19.png';
import portAngelesYachtClubFlag from '../assets/Yacht_Club_Flags/43-PortAngelesYC_Gif.gif';
import portLudlowYachtClubFlag from '../assets/Yacht_Club_Flags/44-portludlow.gif';
import portMadisonYachtClubFlag from '../assets/Yacht_Club_Flags/45-PortMadisonYCGif.gif';
import portOrchardYachtClubFlag from '../assets/Yacht_Club_Flags/46-PortOrchardYachtClub_burgee__52.gif';
import portTownsendYachtClubFlag from '../assets/Yacht_Club_Flags/47-PortTownsendGif.gif';
import poulsboYachtClubFlag from '../assets/Yacht_Club_Flags/48-PoulsboYCGif.gif';
import pugetSoundYachtClubFlag from '../assets/Yacht_Club_Flags/49-PugetSoundYC_Gif.gif';
import quartermasterYachtClubFlag from '../assets/Yacht_Club_Flags/50-QuartermasterYCGif.gif';
import queenCityYachtClubFlag from '../assets/Yacht_Club_Flags/51-QueenCityGif.gif';
import rainierYachtClubFlag from '../assets/Yacht_Club_Flags/52-RanierGif.gif';
import rocheHarborYachtClubFlag from '../assets/Yacht_Club_Flags/53-RocheHarborGif.gif';
import sanJuanIslandYachtClubFlag from '../assets/Yacht_Club_Flags/54-SanJuanIslandYachtClub.gif';
import seabacsYachtClubBoeingCoFlag from '../assets/Yacht_Club_Flags/55-SeabacsGif.gif';
import seattleSinglesYachtClubFlag from '../assets/Yacht_Club_Flags/56-SeattleSinglesGif.gif';
import seattleYachtClubFlag from '../assets/Yacht_Club_Flags/57-SeattleYCGif.gif';
import semiahmooMarinaYachtClubFlag from '../assets/Yacht_Club_Flags/58-SemiahmooYachtClubMarina.jpg';
import semiahmooYachtClubFlag from '../assets/Yacht_Club_Flags/59-SemiahmooYCGif.gif';
import sequimBayYachtClubFlag from '../assets/Yacht_Club_Flags/60-SequimGif.gif';
import shelterBayYachtClubFlag from '../assets/Yacht_Club_Flags/61-ShelterBayYC_burgee.jpg';
import sheltonYachtClubFlag from '../assets/Yacht_Club_Flags/62-SheltonYCGif.gif';
import shilsholeBayYachtClubFlag from '../assets/Yacht_Club_Flags/63-ShilsholeGif.gif';
import sinclairInletYachtClubFlag from '../assets/Yacht_Club_Flags/64-sinclairinletycnew.gif';
import sloopTavernYachtClubFlag from '../assets/Yacht_Club_Flags/65-slooptavern.gif';
import southSoundSailingSocietyFlag from '../assets/Yacht_Club_Flags/66-SouthSoundSS.gif';
import southWhidbeyYachtClubFlag from '../assets/Yacht_Club_Flags/67-SouthWhidbeyYachtClub_2697.jpg';
import squalicumYachtClubFlag from '../assets/Yacht_Club_Flags/68-squalicumyc.gif';
import swinomishYachtClubFlag from '../assets/Yacht_Club_Flags/69-SwinomishGif.gif';
import tacomaYachtClubFlag from '../assets/Yacht_Club_Flags/70-tacoma-yacht-club-burgee-only-web__84.png';
import threeTreePointYachtClubFlag from '../assets/Yacht_Club_Flags/71-ThreeTreePointYachtClub_flag__75.png';
import totemYachtClubFlag from '../assets/Yacht_Club_Flags/72-totemyc.gif';
import tyeeYachtClubSeattleFlag from '../assets/Yacht_Club_Flags/73-TyeeYCSeattleGif.gif';
import vikingYachtClubFlag from '../assets/Yacht_Club_Flags/74-vikingyc.gif';
import washingtonYachtClubFlag from '../assets/Yacht_Club_Flags/75-WashingtonYCGif.gif';
import westSeattleYachtClubFlag from '../assets/Yacht_Club_Flags/76-WSeattleYCGif.gif';
import westSoundCorinthianYachtClubFlag from '../assets/Yacht_Club_Flags/77-WSoundCYCGif.gif';
import yakimaValleyBoatClubFlag from '../assets/Yacht_Club_Flags/78-yakimavalleybc.gif';

import anacortesYachtChartersLogo from '../assets/Charter_Company_Logos/AnacortesYachtCharters-logo-800x800.png';
import freedomBoatClubSeattleLogo from '../assets/Charter_Company_Logos/FreedomBoatClub-logo.png';
import sanJuanSailingYachtingLogo from '../assets/Charter_Company_Logos/SanJuanSailingYachtig-logo-300x300.png';
import seattleSailingClubLogo from '../assets/Charter_Company_Logos/SeattleSailingClub-logo-800x800.png';

export const MOORING_BUOY = 'mooringBuoy';
export const PUBLIC_MOORAGES = 'Public Moorages';

export const BOOKING_PROCESSES = {
  CHARITY_BOOKING_PROCESS_ALIAS: 'charity-booking/release-1',
  DEFAULT_BOOKING_PROCESS_ALIAS: 'default-booking/release-1',
  FREE_BOOKING_PROCESS_ALIAS: 'free-booking/release-1',
};

//Note price is in cents
export const EXTENDED_PRICING_DATA = {
  FOR_LARGE_BUOY: 3000,
  FOR_LARGE_DOCK: 5000,
  FOR_BUOY: 3000,
  FOR_DOCK: 5000,
};

export const DashboadPageNavOption = Object.freeze({
  USER_ACTIONS: 'user-actions',
  LISTING_ACTIVITY: 'listing-activity',
  INBOX_ACTIVITY: 'inbox-activity',
  MESSSAGES: 'messages',
  TRANSACTIONS_DETAILS: 'transactions-details',
  HOST_STATUS_STRIPE: 'host-status-stripe',
  HOST_LISTINGS_SUMMARY: 'host-listigs-summary',
});
export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const UserDetailsOption = Object.freeze({
  USER_NAME: 'username',
  EMAIL: 'email',
  LAST_LOGIN: 'userLastLogin',
  DATE_JOINED: 'profileCreatedAt',
  USER_ID: 'userId',
});
export const HostStripeDetailsOption = Object.freeze({
  HOST_NAME: 'hostName',
  STATUS: 'status',
  BALANCE: 'balance',
  USER_ID: 'userId',
});
export const ListingActivityOption = Object.freeze({
  LISTING_ID: 'listingId',
  TITILE: 'title',
  STATUS: 'status',
  CREATED_AT: 'createdAt',
  LAST_MODIFIED_AT: 'latestModifiedAt',
  HOST_NAME: 'hostName',
});
export const InboxActivityOption = Object.freeze({
  GUEST_NAME: 'guestName',
  HOST_NAME: 'hostName',
  TRANSACTION_ID: 'transactionId',
  MESSAGES: 'messages',
  LISTING_TITLE: 'listingTitle',
  MOST_RECENT_MESSAGE_AT: 'mostRecentMessageAt',
});
export const HostListingsSummaryOption = Object.freeze({
  HOST_NAME: 'hostName',
  USER_ID: 'userId',
  LISTINGS: 'listings',
  TRANSACTIONS_IN_PAST_12_MONTHS: 'transactionsInPast12Months',
});
export const TransactionDetailsPanelOption = Object.freeze({
  TRANSACTION_ID: 'transactionId',
  LISTING_TITLE: 'listingTitle',
  LISTING_URL: 'listingUrl',
  HOST_NAME: 'hostName',
  GUEST_NAME: 'guestName',
  RESERVATION_DATE: 'reservationDate',
  NIGHTS_BOOKED: 'nightsBooked',
  CUSTOMER_PAID_AMOUNT: 'customerPaidAmount',
  LAST_TRANSITION: 'lastTransition',
  TRANSITIONS: 'transitions',
});

export const Environment = Object.freeze({
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
});

export const listingStatus = [
  { key: 'published', label: 'Publised' },
  { key: 'draft', label: 'Draft' },
  { key: 'deleted', label: 'Deleted' },
];

export const transitionStatusMap = {
  'transition/inquire': 'Booking Inquiry',
  'transition/request-payment': 'Pending Payment',
  'transition/request-payment-after-inquiry': 'Pending Payment',
  'transition/confirm-payment': 'Booking Request',
  'transition/confirm-payment-instant': 'Host Accepted',
  'transition/expire-payment': 'Payment Expired',
  'transition/expire': 'Booking Request Expired',
  'transition/decline': 'Host Declined',
  'transition/operator-decline': 'Cancelled (by admin)',
  'transition/accept': 'Host Accepted',
  'transition/operator-accept': 'Host Accepted',
  'transition/cancel': 'Cancelled / Refunded',
  'transition/customer-cancel': 'Cancelled / Refunded',
  'transition/provider-cancel': 'Cancelled / Refunded',
  'transition/provider-cancel-emergency': 'Cancelled / Refunded',
  'transition/complete': 'Stay Completed - Review(s) Pending',
  'transition/operator-complete': 'Stay Completed - Review(s) Pending',
  'transition/review-1-by-provider': 'Stay Completed - Review(s) Pending',
  'transition/review-1-by-customer': 'Stay Completed - Review(s) Pending',
  'transition/review-2-by-provider': 'Stay Completed',
  'transition/review-2-by-customer': 'Stay Completed',
  'transition/expire-customer-review-period': 'Stay Completed',
  'transition/expire-provider-review-period': 'Stay Completed',
  'transition/expire-review-period': 'Stay Completed',
};

const legacyTransition = parts => `transition/${parts.join('-')}`;
const legacyProviderSlug = ['super', 'hog'].join('');
const legacyCheckSlug = ['background', 'check'];
const legacyReviewSlug = ['screen', 'ing'].join('');

const legacyTransitionStatusMap = {
  [legacyTransition([legacyProviderSlug, ...legacyCheckSlug, 'started'])]: 'Booking Request',
  [legacyTransition([legacyProviderSlug, ...legacyCheckSlug, 'passed'])]: 'Booking Request',
  [legacyTransition([
    'instant',
    legacyProviderSlug,
    ...legacyCheckSlug,
    'passed',
  ])]: 'Host Accepted',
  [legacyTransition([legacyProviderSlug, ...legacyCheckSlug, 'failed'])]: 'Cancelled / Refunded',
  [legacyTransition([
    'instant',
    legacyProviderSlug,
    ...legacyCheckSlug,
    'failed',
  ])]: 'Cancelled / Refunded',
  [legacyTransition(['instant', legacyReviewSlug, 'failed'])]: 'Cancelled / Refunded',
  [legacyTransition(['operator', 'approve', 'instant', 'booking'])]: 'Host Accepted',
  [legacyTransition(['operator', 'approve', 'booking'])]: 'Booking Request',
  [legacyTransition(['operator', 'reject', 'instant', 'booking'])]: 'Cancelled (by admin)',
  [legacyTransition(['operator', 'reject', 'booking'])]: 'Cancelled (by admin)',
};

export const getTransitionStatusLabel = transition => {
  return transitionStatusMap[transition] || legacyTransitionStatusMap[transition] || null;
};

export const statusOptions = [
  { key: '', label: 'All Statuses' },
  { key: 'Booking Inquiry', label: 'Booking Inquiry' },
  { key: 'Pending Payment', label: 'Pending Payment' },
  { key: 'Booking Request', label: 'Booking Request' },
  { key: 'Payment Expired', label: 'Payment Expired' },
  { key: 'Booking Request Expired', label: 'Booking Request Expired' },
  { key: 'Host Declined', label: 'Host Declined' },
  { key: 'Host Accepted', label: 'Host Accepted' },
  { key: 'Cancelled (by admin)', label: 'Cancelled (by admin)' },
  { key: 'Cancelled / Refunded', label: 'Cancelled / Refunded' },
  { key: 'Stay Completed - Review(s) Pending', label: 'Stay Completed - Review(s) Pending' },
  { key: 'Stay Completed', label: 'Stay Completed' },
];

export const stripeStatusOptions = [
  { key: '', label: 'All Stripe Statuses' },
  { key: 'Complete', label: 'Complete' },
  { key: 'Pending', label: 'Pending' },
  { key: 'Restricted Soon', label: 'Restricted Soon' },
  { key: 'Restricted', label: 'Restricted' },
  { key: 'Enabled', label: 'Enabled' },
  { key: 'No Stripe Account', label: 'No Stripe Account' },
  { key: 'Error Fetching Account', label: 'Error Fetching Account' },
];

export const PhoneVerificationSteps = Object.freeze({
  Step_1: 0,
  Step_2: 1,
});

export const SignupSteps = Object.freeze({
  EMAIL: 'email',
  DETAILS: 'details',
  PHONE: 'phone',
  PASSWORD: 'password',
});

export const SupportPageFAQTitles = ['aboutHelp', 'guestHelp', 'hostHelp', 'hostToolkit'];

export const SearchType = {
  KEYWORDS: 'keywords',
  LOCATION: 'location',
};

export const NOTIFICATION_TYPES = {
  EMAIL: 'email',
  PHONE: 'phone',
};

export const CHARTER_COMPANIES = [
  { key: '', value: 'Please select an option', logoUrl: '', websiteUrl: '', disabled: true },
  {
    key: 'anacortes yacht charters',
    value: 'Anacortes Yacht Charters',
    logoUrl: anacortesYachtChartersLogo,
    websiteUrl: 'https://anacortesyachtcharters.com/charter-fleet/',
    disabled: false,
  },
  {
    key: 'freedom boat club seattle',
    value: 'Freedom Boat Club Seattle',
    logoUrl: freedomBoatClubSeattleLogo,
    websiteUrl: 'https://info.freedomboatclub.com/dp/seattle',
    disabled: false,
  },
  {
    key: 'san juan sailing & yachting',
    value: 'San Juan Sailing & Yachting',
    logoUrl: sanJuanSailingYachtingLogo,
    websiteUrl: 'https://sanjuanyachting.com/charters.html',
    disabled: false,
  },
  {
    key: 'seattle sailing club',
    value: 'Seattle Sailing Club',
    logoUrl: seattleSailingClubLogo,
    websiteUrl: 'https://seattlesailing.com/',
    disabled: false,
  },
  { key: 'other', value: 'Other', logoUrl: '', websiteUrl: '', disabled: false },
];

const anacortesYachtChartersVessels = [
  { key: '', value: 'Please select an option', disabled: true },
  {
    key: 'blue',
    value: 'BLUE',
    disabled: false,
    year: '2016',
    make: 'Ranger Tug',
    model: '27',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '27',
    beam: '8.5',
    draft: '3',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'rosie',
    value: 'ROSIE',
    disabled: false,
    year: '2017',
    make: 'Ranger Tug',
    model: '29',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '29',
    beam: '10',
    draft: '2.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'serendipity',
    value: 'SERENDIPITY',
    disabled: false,
    year: '2012',
    make: 'Ranger Tug',
    model: '29',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '29',
    beam: '10',
    draft: '2.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'mi callao',
    value: 'MI CALLAO',
    disabled: false,
    year: '2015',
    make: 'Ranger Tug',
    model: '31',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '31',
    beam: '10',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'artemis',
    value: 'ARTEMIS',
    disabled: false,
    year: '1999',
    make: 'Nordic Tug',
    model: '32',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '32',
    beam: '11',
    draft: '3',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'blind squirrel',
    value: 'BLIND SQUIRREL',
    disabled: false,
    year: '2006',
    make: 'Silverton',
    model: '35',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '35',
    beam: '13.5',
    draft: '3',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'gratitude-c',
    value: 'GRATITUDE-C',
    disabled: false,
    year: '1992',
    make: 'Grand Banks',
    model: '36',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36',
    beam: '12.5',
    draft: '4',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'kairos',
    value: 'KAIROS',
    disabled: false,
    year: '2005',
    make: 'Selene',
    model: '36',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36',
    beam: '14.5',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'sea star',
    value: 'SEA STAR',
    disabled: false,
    year: '1979',
    make: 'Hershine',
    model: '37',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '37',
    beam: '14',
    draft: '4',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'sea of memories',
    value: 'SEA OF MEMORIES',
    disabled: false,
    year: '2006',
    make: 'Silverton',
    model: '38 Sport Bridge',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '38',
    beam: '14',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'la passage',
    value: 'LA PASSAGE',
    disabled: false,
    year: '2020',
    make: 'Greenline',
    model: '39',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39',
    beam: '12.5',
    draft: '3',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'cascadia',
    value: 'CASCADIA',
    disabled: false,
    year: '1998',
    make: 'Bayliner',
    model: '4087',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '40',
    beam: '13',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'old soul',
    value: 'OLD SOUL',
    disabled: false,
    year: '1980',
    make: 'CHB',
    model: '42',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42',
    beam: '13.5',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'the seeker',
    value: 'THE SEEKER',
    disabled: false,
    year: '1990',
    make: 'Golden Star',
    model: '42',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42',
    beam: '15',
    draft: '4',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'gratitude',
    value: 'GRATITUDE',
    disabled: false,
    year: '1993',
    make: 'Bayliner',
    model: '43',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '43',
    beam: '14',
    draft: '3',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'latis',
    value: 'LATIS',
    disabled: false,
    year: '1988',
    make: 'Grand Banks',
    model: '46',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '47.5',
    beam: '15',
    draft: '7.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'goodlife',
    value: 'GOODLIFE',
    disabled: false,
    year: '1998',
    make: 'Grand Banks',
    model: '46 Europa',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '46',
    beam: '15',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'starlight express',
    value: 'STARLIGHT EXPRESS',
    disabled: false,
    year: '2000',
    make: 'Bayliner',
    model: '47',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '47',
    beam: '15',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'chinook',
    value: 'CHINOOK',
    disabled: false,
    year: '1998',
    make: 'Bayliner',
    model: '4788',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '47',
    beam: '15',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'blue moon',
    value: 'BLUE MOON',
    disabled: false,
    year: '2000',
    make: 'Sabreline',
    model: '47',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '47',
    beam: '15',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'hullabaloo',
    value: 'HULLABALOO',
    disabled: false,
    year: '1986',
    make: 'Sea Ranger',
    model: '47',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '47',
    beam: '15',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'voyager',
    value: 'VOYAGER',
    disabled: false,
    year: '1980',
    make: 'DeFever',
    model: '48',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '48',
    beam: '15',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'gypsy drifter',
    value: 'GYPSY DRIFTER',
    disabled: false,
    year: '1999',
    make: 'Ocean Alexander',
    model: '48',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '48',
    beam: '15.5',
    draft: '4',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'magic',
    value: 'MAGIC',
    disabled: false,
    year: '2004',
    make: 'Meridian',
    model: '490 Pilothouse',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '49',
    beam: '15',
    draft: '3.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'lady b',
    value: 'LADY B',
    disabled: false,
    year: '1982',
    make: 'Ocean Alexander',
    model: '50',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '50',
    beam: '15.5',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'ocean observer',
    value: 'OCEAN OBSERVER',
    disabled: false,
    year: '2007',
    make: 'Carver',
    model: '52 Voyager',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '52',
    beam: '15.5',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'orca belle',
    value: 'ORCA BELLE',
    disabled: false,
    year: '2000',
    make: 'Navigator',
    model: '53',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '57',
    beam: '15',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'peisinoe',
    value: 'PEISINOE',
    disabled: false,
    year: '2000',
    make: 'Navigator',
    model: '53',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '57',
    beam: '15',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'velvet moose',
    value: 'VELVET MOOSE',
    disabled: false,
    year: '2003',
    make: 'Selene',
    model: '53',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '60',
    beam: '17',
    draft: '6',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'ohana-s',
    value: 'OHANA-S',
    disabled: false,
    year: '2006',
    make: 'Carver',
    model: '56',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '59.5',
    beam: '15',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'meg ann iii',
    value: 'MEG ANN III',
    disabled: false,
    year: '1998',
    make: 'Bayliner',
    model: '57',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '57',
    beam: '17',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'querencia',
    value: 'QUERENCIA',
    disabled: false,
    year: '2002',
    make: 'Carver',
    model: '57 Voyager',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '59',
    beam: '15.5',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'annecole',
    value: 'ANNECOLE',
    disabled: false,
    year: '2004',
    make: 'Navigator',
    model: '57 Rival',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '57',
    beam: '15',
    draft: '4.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'heavenly daze',
    value: 'HEAVENLY DAZE',
    disabled: false,
    year: '2006',
    make: 'Selene',
    model: '57 Ocean Trawler',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '63',
    beam: '17',
    draft: '7',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'gratitude-h',
    value: 'GRATITUDE-H',
    disabled: false,
    year: '2004',
    make: 'Ocean Alexander',
    model: '58',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '62',
    beam: '17.5',
    draft: '4',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'tahoe',
    value: 'TAHOE',
    disabled: false,
    year: '1996',
    make: 'Queenship',
    model: '59 Pilothouse',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '59',
    beam: '17',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'good decisions',
    value: 'GOOD DECISIONS',
    disabled: false,
    year: '2006',
    make: 'Ocean Alexander',
    model: '64 Pilothouse',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '70',
    beam: '17.5',
    draft: '4',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'lady georgia',
    value: 'LADY GEORGIA',
    disabled: false,
    year: '1996',
    make: 'Queenship',
    model: '66',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '66',
    beam: '18',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'ocean romance',
    value: 'OCEAN ROMANCE',
    disabled: false,
    year: '1988',
    make: 'Hatteras',
    model: '70 FDMY',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '71',
    beam: '18',
    draft: '5.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'maritana',
    value: 'MARITANA',
    disabled: false,
    year: '2004',
    make: 'Beneteau',
    model: 'Oceanis 331',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34',
    beam: '11',
    draft: '5.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'escape',
    value: 'ESCAPE',
    disabled: false,
    year: '1999',
    make: 'Bavaria',
    model: '36',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '37.5',
    beam: '12',
    draft: '6.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'la dolce vita',
    value: 'LA DOLCE VITA',
    disabled: false,
    year: '2000',
    make: 'Beneteau',
    model: 'Oceanis 361',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36.5',
    beam: '12.5',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'aquarius',
    value: 'AQUARIUS',
    disabled: false,
    year: '1987',
    make: 'Baba Tashiba',
    model: '40',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '40',
    beam: '13',
    draft: '6',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'harriet tubman',
    value: 'HARRIET TUBMAN',
    disabled: false,
    year: '2002',
    make: 'Caliber',
    model: '40',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41',
    beam: '12',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'second passage',
    value: 'SECOND PASSAGE',
    disabled: false,
    year: '2005',
    make: 'Hunter',
    model: '41',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41',
    beam: '13',
    draft: '6.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: "a li'l r & r",
    value: "A LI'L R & R",
    disabled: false,
    year: '2005',
    make: 'Catalina',
    model: '42 Mark II',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '43',
    beam: '14',
    draft: '7',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'hanalei',
    value: 'HANALEI',
    disabled: false,
    year: '2011',
    make: 'Jeanneau',
    model: '44',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45',
    beam: '14.5',
    draft: '7',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'braesail',
    value: 'BRAESAIL',
    disabled: false,
    year: '2001',
    make: 'Moody',
    model: '46',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '49',
    beam: '14.5',
    draft: '7',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'ohana - v',
    value: 'OHANA - V',
    disabled: false,
    year: '2015',
    make: 'Jeanneau',
    model: '509 Sun Odyssey',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '50.5',
    beam: '15.5',
    draft: '7.5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'blew by u',
    value: 'BLEW BY U',
    disabled: false,
    year: '6',
    make: 'Beneteau',
    model: '51 Cyclades',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '51',
    beam: '16',
    draft: '7',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
  {
    key: 'laura marie',
    value: 'LAURA MARIE',
    disabled: false,
    year: '2015',
    make: 'Leopard Cat',
    model: '48',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '48.5',
    beam: '25',
    draft: '5',
    hailingPort: 'Anacortes Yacht Charters',
    insurance: 'On File',
  },
];

const freedomBoatClubSeattleVessels = [
  { key: '', value: 'Please select an option', disabled: true },
  {
    key: 'fbc cabin cruiser / extended nav',
    value: 'FBC Cabin Cruiser / Extended Nav',
    disabled: false,
    year: '2016 or newer',
    make: 'Beneteau (or similar)',
    model: 'Cabin Cruiser',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '24.5',
    beam: '8',
    draft: '3',
    hailingPort: 'Freedom Boat Club',
    insurance: 'On File',
  },
  {
    key: 'fbc pilothouse / extended nav',
    value: 'FBC Pilothouse / Extended Nav',
    disabled: false,
    year: '2016 or newer',
    make: 'Defiance (or similar)',
    model: 'Pilothouse',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '25',
    beam: '8.5',
    draft: '2.5',
    hailingPort: 'Freedom Boat Club',
    insurance: 'On File',
  },
];

const sanJuanSailingYachtingVessels = [
  { key: '', value: 'Please select an option', disabled: true },
  {
    key: 'sea wings',
    value: 'Sea Wings',
    disabled: false,
    year: '2006',
    make: 'Navigator',
    model: '51',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '56',
    beam: '15',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'salish dawn',
    value: 'Salish Dawn',
    disabled: false,
    year: '2011',
    make: 'Seahorse',
    model: '52',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '54',
    beam: '15.5',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'moondance',
    value: 'Moondance',
    disabled: false,
    year: '2023',
    make: 'North Pacific',
    model: '49',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '54.5',
    beam: '15.5',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'san juan spirit',
    value: 'San Juan Spirit',
    disabled: false,
    year: '2026',
    make: 'Helmsman',
    model: '43 Sedan',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45.6',
    beam: '14',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'gray pearl',
    value: 'Gray Pearl',
    disabled: false,
    year: '2011',
    make: 'American Tug',
    model: '435',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '43.5',
    beam: '16',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'temana',
    value: 'Temana',
    disabled: false,
    year: '1996',
    make: 'Grand Banks',
    model: '42 Motoyacht',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '46.5',
    beam: '14',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'mariah',
    value: 'Mariah',
    disabled: false,
    year: '2004',
    make: 'Nordic Tug',
    model: '42',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '49',
    beam: '14',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'indigo odyssey',
    value: 'Indigo Odyssey',
    disabled: false,
    year: '2007',
    make: 'Nordic Tug',
    model: '42',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '46.5',
    beam: '14',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'solitude',
    value: 'Solitude',
    disabled: false,
    year: '2015',
    make: 'Selene',
    model: 'Europa 42',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '44.5',
    beam: '14.5',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'amyann',
    value: 'AmyAnn',
    disabled: false,
    year: '2018',
    make: 'Helmsman',
    model: '38E Pilothouse',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41',
    beam: '14',
    draft: '4',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'osprey',
    value: 'Osprey',
    disabled: false,
    year: '2006',
    make: 'Nordic Tug 37',
    model: '37',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39',
    beam: '13',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'island eagle',
    value: 'Island Eagle',
    disabled: false,
    year: '2025',
    make: 'American Tug',
    model: '362',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36.5',
    beam: '13',
    draft: '3.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'san juan explorer',
    value: 'San Juan Explorer',
    disabled: false,
    year: '2020',
    make: 'American Tug',
    model: '362',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36.5',
    beam: '13',
    draft: '3.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'true blue',
    value: 'True Blue',
    disabled: false,
    year: '2012',
    make: 'American Tug',
    model: '365',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36.5',
    beam: '13',
    draft: '3.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'island time',
    value: 'Island Time',
    disabled: false,
    year: '2004',
    make: 'American Tug',
    model: '34',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '36.5',
    beam: '13',
    draft: '3.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'do it now',
    value: 'Do It Now',
    disabled: false,
    year: '2019',
    make: 'Ranger Tug',
    model: '29CB',
    type: 'Powerboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '33.5',
    beam: '10',
    draft: '2.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'thin air',
    value: 'Thin Air',
    disabled: false,
    year: '2015',
    make: 'Fountaine Pajot',
    model: 'Lipari 41',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39.5',
    beam: '22',
    draft: '4',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'zephyr',
    value: 'Zephyr',
    disabled: false,
    year: '2022',
    make: 'Seawind',
    model: "1260 (41')",
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41',
    beam: '22',
    draft: '4',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'escape',
    value: 'Escape',
    disabled: false,
    year: '2016',
    make: 'Nautitech',
    model: 'Open 40',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39.5',
    beam: '22',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'kia orana',
    value: 'Kia Orana',
    disabled: false,
    year: '2017',
    make: 'Lagoon',
    model: '39',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '38.5',
    beam: '22',
    draft: '4',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'mokimak',
    value: 'MokiMak',
    disabled: false,
    year: '2015',
    make: 'Seawind',
    model: '1160',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '38',
    beam: '21.5',
    draft: '4',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'orion',
    value: 'Orion',
    disabled: false,
    year: '',
    make: '',
    model: '',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '',
    beam: '',
    draft: '',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'obelix',
    value: 'Obelix',
    disabled: false,
    year: '2015',
    make: 'Garcia',
    model: 'Exporation 45',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45',
    beam: '14.5',
    draft: '9.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'natsumi',
    value: 'Natsumi',
    disabled: false,
    year: '2018',
    make: 'Beneteau',
    model: '45',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45.5',
    beam: '15',
    draft: '7.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'wind dancer',
    value: 'Wind Dancer',
    disabled: false,
    year: '2015',
    make: 'Hanse',
    model: '455',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45.5',
    beam: '14.5',
    draft: '7.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'lady grey',
    value: 'Lady Grey',
    disabled: false,
    year: '2016',
    make: 'Beneteau',
    model: '45',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45.5',
    beam: '15',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'misty blue yonder',
    value: 'Misty Blue Yonder',
    disabled: false,
    year: '1995',
    make: 'Jeanneau',
    model: '45',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '50',
    beam: '14.5',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'esprit de mer',
    value: 'Esprit de Mer',
    disabled: false,
    year: '1999',
    make: 'Jeanneau',
    model: '45',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '46.5',
    beam: '14.5',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'spiritus',
    value: 'Spiritus',
    disabled: false,
    year: '2023',
    make: 'Jeanneau',
    model: 'Sun Odyssey 440',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '44',
    beam: '14',
    draft: '7.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: "sea's the dream",
    value: "Sea's the Dream",
    disabled: false,
    year: '2013',
    make: 'Jeanneau',
    model: '44 DS',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '44',
    beam: '14',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'vita beàta',
    value: 'Vita Beàta',
    disabled: false,
    year: '2008',
    make: 'Island Packet',
    model: '440',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45.5',
    beam: '14.5',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'illuminé',
    value: 'Illuminé',
    disabled: false,
    year: '2005',
    make: 'Jeanneau',
    model: '43DS',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '43.5',
    beam: '13.5',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'kipper kite',
    value: 'Kipper Kite',
    disabled: false,
    year: '1997',
    make: 'Beneteau',
    model: '42',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42.5',
    beam: '13.5',
    draft: '6',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'cascadia',
    value: 'Cascadia',
    disabled: false,
    year: '2021',
    make: 'Jeanneau',
    model: '410',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42.5',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'reliance',
    value: 'Reliance',
    disabled: false,
    year: '2016',
    make: 'Hanse',
    model: '415',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41',
    beam: '13.5',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'raven',
    value: 'Raven',
    disabled: false,
    year: '2016',
    make: 'Jeanneau',
    model: '419',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'fresh aire',
    value: 'Fresh Aire',
    disabled: false,
    year: '2016',
    make: 'Bavaria',
    model: '41',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '40.5',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'interlude',
    value: 'Interlude',
    disabled: false,
    year: '2017',
    make: 'Beneteau',
    model: '41.1',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41',
    beam: '14',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'at last',
    value: 'At Last',
    disabled: false,
    year: '2017',
    make: 'Jeanneau',
    model: '419',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'marie katherine',
    value: 'Marie Katherine',
    disabled: false,
    year: '2022',
    make: 'Beneteau',
    model: '40.1',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '42.3',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'spirited away',
    value: 'Spirited Away',
    disabled: false,
    year: '2016',
    make: 'Jeanneau',
    model: '409',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '40.5',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'sage',
    value: 'Sage',
    disabled: false,
    year: '2016',
    make: 'Hunter',
    model: '40',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '41.5',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'windwaker',
    value: 'Windwaker',
    disabled: false,
    year: '2011',
    make: 'Jeanneau',
    model: '409',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '40.5',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'stargazer',
    value: 'Stargazer',
    disabled: false,
    year: '2019',
    make: 'Tartan',
    model: '395',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39.5',
    beam: '13',
    draft: '5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'kallisto',
    value: 'Kallisto',
    disabled: false,
    year: '2010',
    make: 'Jeanneau',
    model: '39',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39',
    beam: '13',
    draft: '7',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'orca',
    value: 'Orca',
    disabled: false,
    year: '2023',
    make: 'Jeanneau',
    model: '380',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '38.5',
    beam: '12',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'amazing grace',
    value: 'Amazing Grace',
    disabled: false,
    year: '2017',
    make: 'Bavaria',
    model: '37',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '37',
    beam: '12',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'allora',
    value: 'Allora',
    disabled: false,
    year: '2011',
    make: 'Beneteau',
    model: '37',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '37.5',
    beam: '13',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'chinook',
    value: 'Chinook',
    disabled: false,
    year: '2005',
    make: 'Beneteau',
    model: '37',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '37',
    beam: '12.5',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'sea otter',
    value: 'Sea Otter',
    disabled: false,
    year: '1987',
    make: 'Island Packet',
    model: '37',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '38.5',
    beam: '12',
    draft: '4.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'areté',
    value: 'Areté',
    disabled: false,
    year: '2003',
    make: 'Bavaria',
    model: '36',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '38',
    beam: '12',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'imagine',
    value: 'Imagine',
    disabled: false,
    year: '2017',
    make: 'Jeanneau',
    model: '349',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34',
    beam: '11.5',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'mirage',
    value: 'Mirage',
    disabled: false,
    year: '2011',
    make: 'Beneteau',
    model: '34',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34',
    beam: '12',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'cecilia',
    value: 'Cecilia',
    disabled: false,
    year: '2006',
    make: 'Tartan',
    model: '3400',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '12',
    draft: '6.5',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
  {
    key: 'katara',
    value: 'Katara',
    disabled: false,
    year: '2020',
    make: 'Hallberg-Rassy',
    model: '310',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '31',
    beam: '10.5',
    draft: '6',
    hailingPort: 'San Juan Sailing & Yachting',
    insurance: 'On File',
  },
];

const seattleSailingClubVessels = [
  { key: '', value: 'Please select an option', disabled: true },
  {
    key: 'leif',
    value: 'Leif',
    disabled: false,
    year: '1972',
    make: 'Ericson',
    model: '26S',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '26.5',
    beam: '9.5',
    draft: '5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'blew moon',
    value: 'Blew Moon',
    disabled: false,
    year: '2016',
    make: 'C&C',
    model: '27',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '26.5',
    beam: '9.5',
    draft: '5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'makai',
    value: 'Makai',
    disabled: false,
    year: '2017',
    make: 'C&C',
    model: '27',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '26.5',
    beam: '9.5',
    draft: '5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'pendragon',
    value: 'PenDragon',
    disabled: false,
    year: '2016',
    make: 'C&C',
    model: '27',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '26.5',
    beam: '9.5',
    draft: '5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'moshi',
    value: 'Moshi',
    disabled: false,
    year: 'On File',
    make: 'Beneteau',
    model: 'Oceanis 31',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '32',
    beam: '11',
    draft: '6',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'bluelight',
    value: 'Bluelight',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'creative',
    value: 'Creative',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'jaded',
    value: 'Jaded',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'mazu',
    value: 'Mazu',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'moonglow',
    value: 'Moonglow',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'paladin',
    value: 'Paladin',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'puff',
    value: 'Puff',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '105',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'astraea',
    value: 'Astraea',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '35C',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '35.5',
    beam: '12',
    draft: '7',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'la dolce vita',
    value: 'La Dolce Vita',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '35C',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '35.5',
    beam: '12',
    draft: '7',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'no name/irene',
    value: 'No Name/Irene',
    disabled: false,
    year: 'On File',
    make: 'J',
    model: '35C',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '35.5',
    beam: '12',
    draft: '7',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'silver girl',
    value: 'Silver Girl',
    disabled: false,
    year: 'On File',
    make: 'Hanse',
    model: '342',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '34.5',
    beam: '11',
    draft: '6',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'allons-y',
    value: 'Allons-y',
    disabled: false,
    year: 'On File',
    make: 'Dehler',
    model: '38SQ',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '39.5',
    beam: '12.5',
    draft: '7',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'cemre',
    value: 'Cemre',
    disabled: false,
    year: 'On File',
    make: 'Beneteau',
    model: 'Oceanis 40',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '40',
    beam: '13',
    draft: '3.5',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'colibrí',
    value: 'Colibrí',
    disabled: false,
    year: 'On File',
    make: 'Jeanneau',
    model: '45',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '45',
    beam: '14.5',
    draft: '7',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
  {
    key: 'why knot',
    value: 'Why Knot',
    disabled: false,
    year: 'On File',
    make: 'Excess',
    model: '11',
    type: 'Sailboat',
    registrationState: 'US Coast Guard',
    registrationNumber: 'On File',
    length: '37.5',
    beam: '22',
    draft: '4',
    hailingPort: 'Seattle Sailing Club',
    insurance: 'On File',
  },
];

export const VESSELS_BY_COMPANY = {
  'anacortes yacht charters': anacortesYachtChartersVessels,
  'freedom boat club seattle': freedomBoatClubSeattleVessels,
  'san juan sailing & yachting': sanJuanSailingYachtingVessels,
  'seattle sailing club': seattleSailingClubVessels,
};

export const YACHT_CLUBS = [
  { key: '', value: 'Select a Yacht Club', flagUrl: '', websiteUrl: '', disabled: true },
  {
    key: 'anacortes yacht club',
    value: 'Anacortes Yacht Club',
    flagUrl: anacortesYachtClubFlag,
    websiteUrl: 'http://www.anacortesyachtclub.org/',
    disabled: false,
  },
  {
    key: 'bellevue yacht club',
    value: 'Bellevue Yacht Club',
    flagUrl: bellevueYachtClubFlag,
    websiteUrl: 'http://www.bellevueyachtclub.com/',
    disabled: false,
  },
  {
    key: 'bellingham yacht club',
    value: 'Bellingham Yacht Club',
    flagUrl: bellinghamYachtClubFlag,
    websiteUrl: 'http://www.byc.org/',
    disabled: false,
  },
  {
    key: 'birch bay village yacht club',
    value: 'Birch Bay Village Yacht Club',
    flagUrl: birchBayVillageYachtClubFlag,
    websiteUrl: 'http://www.bbvyc.org/',
    disabled: false,
  },
  {
    key: 'bremerton yacht club',
    value: 'Bremerton Yacht Club',
    flagUrl: bremertonYachtClubFlag,
    websiteUrl: 'http://www.bremertonyachtclub.org/',
    disabled: false,
  },
  {
    key: 'brownsville yacht club',
    value: 'Brownsville Yacht Club',
    flagUrl: brownsvilleYachtClubFlag,
    websiteUrl: 'https://www.brownsvilleyachtclub.org/',
    disabled: false,
  },
  {
    key: 'camano island yacht club',
    value: 'Camano Island Yacht Club',
    flagUrl: camanoIslandYachtClubFlag,
    websiteUrl: 'http://www.camanoislandyc.com/',
    disabled: false,
  },
  {
    key: 'carling yacht club',
    value: 'Carling Yacht Club',
    flagUrl: carlingYachtClubFlag,
    websiteUrl: 'http://www.carlingyachtclub.com/',
    disabled: false,
  },
  {
    key: 'corinthian yacht club of bellingham',
    value: 'Corinthian Yacht Club of Bellingham',
    flagUrl: corinthianYachtClubOfBellinghamFlag,
    websiteUrl: 'http://www.cycbellingham.org/',
    disabled: false,
  },
  {
    key: 'corinthian yacht club of edmonds',
    value: 'Corinthian Yacht Club of Edmonds',
    flagUrl: corinthianYachtClubOfEdmondsFlag,
    websiteUrl: 'http://cycedmonds.org/',
    disabled: false,
  },
  {
    key: 'corinthian yacht club of seattle',
    value: 'Corinthian Yacht Club of Seattle',
    flagUrl: corinthianYachtClubOfSeattleFlag,
    websiteUrl: 'http://www.cycseattle.org/',
    disabled: false,
  },
  {
    key: 'corinthian yacht club of tacoma',
    value: 'Corinthian Yacht Club of Tacoma',
    flagUrl: corinthianYachtClubOfTacomaFlag,
    websiteUrl: 'http://www.cyct.com/',
    disabled: false,
  },
  {
    key: 'dagmars yacht club',
    value: 'Dagmars Yacht Club',
    flagUrl: dagmarsYachtClubFlag,
    websiteUrl: 'https://dagmarsyc.clubexpress.com/',
    disabled: false,
  },
  {
    key: 'day island yacht club',
    value: 'Day Island Yacht Club',
    flagUrl: dayIslandYachtClubFlag,
    websiteUrl: 'http://www.dayislandyc.org/',
    disabled: false,
  },
  {
    key: 'deer harbor yacht club',
    value: 'Deer Harbor Yacht Club',
    flagUrl: deerHarborYachtClubFlag,
    websiteUrl: 'http://dhyc.org/',
    disabled: false,
  },
  {
    key: 'des moines yacht club',
    value: 'Des Moines Yacht Club',
    flagUrl: desMoinesYachtClubFlag,
    websiteUrl: 'http://www.desmoinesyachtclub.com/',
    disabled: false,
  },
  {
    key: 'duwamish yacht club',
    value: 'Duwamish Yacht Club',
    flagUrl: duwamishYachtClubFlag,
    websiteUrl: 'http://www.duwamishyachtclub.com/',
    disabled: false,
  },
  {
    key: 'eagle harbor yacht club',
    value: 'Eagle Harbor Yacht Club',
    flagUrl: eagleHarborYachtClubFlag,
    websiteUrl: 'http://eagleharboryachtclub.com/',
    disabled: false,
  },
  {
    key: 'edmonds yacht club',
    value: 'Edmonds Yacht Club',
    flagUrl: edmondsYachtClubFlag,
    websiteUrl: 'http://www.edmondsyachtclub.com/',
    disabled: false,
  },
  {
    key: 'emerald rose yacht club',
    value: 'Emerald Rose Yacht Club',
    flagUrl: emeraldRoseYachtClubFlag,
    websiteUrl: 'http://emeraldroseyc.com/',
    disabled: false,
  },
  {
    key: 'everett yacht club',
    value: 'Everett Yacht Club',
    flagUrl: everettYachtClubFlag,
    websiteUrl: 'http://www.everettyachtclub.com/',
    disabled: false,
  },
  {
    key: 'fidalgo yacht club',
    value: 'Fidalgo Yacht Club',
    flagUrl: fidalgoYachtClubFlag,
    websiteUrl: 'http://www.fidalgoyachtclub.org/',
    disabled: false,
  },
  {
    key: 'fircrest yacht club',
    value: 'Fircrest Yacht Club',
    flagUrl: fircrestYachtClubFlag,
    websiteUrl: 'http://www.fircrestyc.org/',
    disabled: false,
  },
  {
    key: 'flounder bay yacht club',
    value: 'Flounder Bay Yacht Club',
    flagUrl: flounderBayYachtClubFlag,
    websiteUrl: 'http://www.flounderbayyc.com/',
    disabled: false,
  },
  {
    key: 'fox island yacht club',
    value: 'Fox Island Yacht Club',
    flagUrl: foxIslandYachtClubFlag,
    websiteUrl: 'http://www.fiyc.com/',
    disabled: false,
  },
  {
    key: 'gig harbor yacht club',
    value: 'Gig Harbor Yacht Club',
    flagUrl: gigHarborYachtClubFlag,
    websiteUrl: 'http://www.gigharboryc.com/',
    disabled: false,
  },
  {
    key: 'hat island yacht & golf club',
    value: 'Hat Island Yacht & Golf Club',
    flagUrl: hatIslandYachtGolfClubFlag,
    websiteUrl: 'http://www.hatislandyachtclub.com/',
    disabled: false,
  },
  {
    key: 'hidden harbor yacht club',
    value: 'Hidden Harbor Yacht Club',
    flagUrl: hiddenHarborYachtClubFlag,
    websiteUrl: 'http://hhycseattle.com/',
    disabled: false,
  },
  {
    key: 'kingston cove yacht club',
    value: 'Kingston Cove Yacht Club',
    flagUrl: kingstonCoveYachtClubFlag,
    websiteUrl: 'http://kcyc.org/',
    disabled: false,
  },
  {
    key: 'la conner yacht club',
    value: 'La Conner Yacht Club',
    flagUrl: laConnerYachtClubFlag,
    websiteUrl: 'http://laconneryc.org/',
    disabled: false,
  },
  {
    key: 'lopez island yacht club',
    value: 'Lopez Island Yacht Club',
    flagUrl: lopezIslandYachtClubFlag,
    websiteUrl: 'http://lopezislandyachtclub.com/',
    disabled: false,
  },
  {
    key: 'meydenbauer bay yacht club',
    value: 'Meydenbauer Bay Yacht Club',
    flagUrl: meydenbauerBayYachtClubFlag,
    websiteUrl: 'http://www.mbycwa.org/',
    disabled: false,
  },
  {
    key: 'milltown sailing association',
    value: 'Milltown Sailing Association',
    flagUrl: milltownSailingAssociationFlag,
    websiteUrl: 'http://www.milltownsailing.org/',
    disabled: false,
  },
  {
    key: 'mukilteo yacht club',
    value: 'Mukilteo Yacht Club',
    flagUrl: mukilteoYachtClubFlag,
    websiteUrl: 'http://www.mukilteoyachtclub.com/',
    disabled: false,
  },
  {
    key: 'navy yacht club - everett',
    value: 'Navy Yacht Club - Everett',
    flagUrl: navyYachtClubEverettFlag,
    websiteUrl: 'http://www.navyyachtclubeverett.com/',
    disabled: false,
  },
  {
    key: 'oak harbor yacht club',
    value: 'Oak Harbor Yacht Club',
    flagUrl: oakHarborYachtClubFlag,
    websiteUrl: 'http://www.ohyc.org/',
    disabled: false,
  },
  {
    key: 'olympia yacht club',
    value: 'Olympia Yacht Club',
    flagUrl: olympiaYachtClubFlag,
    websiteUrl: 'https://www.theolympiayachtclub.com/',
    disabled: false,
  },
  {
    key: 'orcas island yacht club',
    value: 'Orcas Island Yacht Club',
    flagUrl: orcasIslandYachtClubFlag,
    websiteUrl: 'http://oiyc.org/',
    disabled: false,
  },
  {
    key: 'oro bay yacht club',
    value: 'Oro Bay Yacht Club',
    flagUrl: oroBayYachtClubFlag,
    websiteUrl: 'http://orobayyc.org/',
    disabled: false,
  },
  {
    key: 'pleasant harbor yacht club',
    value: 'Pleasant Harbor Yacht Club',
    flagUrl: pleasantHarborYachtClubFlag,
    websiteUrl: 'https://pleasantharboryc.net/',
    disabled: false,
  },
  {
    key: 'point roberts marina resort',
    value: 'Point Roberts Marina Resort',
    flagUrl: pointRobertsMarinaResortFlag,
    websiteUrl: 'http://www.pointrobertsmarina.com/',
    disabled: false,
  },
  {
    key: 'point roberts yacht club',
    value: 'Point Roberts Yacht Club',
    flagUrl: pointRobertsYachtClubFlag,
    websiteUrl: 'http://www.pointrobertsyachtclub.com/',
    disabled: false,
  },
  {
    key: 'port angeles yacht club',
    value: 'Port Angeles Yacht Club',
    flagUrl: portAngelesYachtClubFlag,
    websiteUrl: 'http://www.payc.org/',
    disabled: false,
  },
  {
    key: 'port ludlow yacht club',
    value: 'Port Ludlow Yacht Club',
    flagUrl: portLudlowYachtClubFlag,
    websiteUrl: 'http://www.plyc.us/',
    disabled: false,
  },
  {
    key: 'port madison yacht club',
    value: 'Port Madison Yacht Club',
    flagUrl: portMadisonYachtClubFlag,
    websiteUrl: 'http://portmadisonyc.org/',
    disabled: false,
  },
  {
    key: 'port orchard yacht club',
    value: 'Port Orchard Yacht Club',
    flagUrl: portOrchardYachtClubFlag,
    websiteUrl: 'http://www.poyc.org/',
    disabled: false,
  },
  {
    key: 'port townsend yacht club',
    value: 'Port Townsend Yacht Club',
    flagUrl: portTownsendYachtClubFlag,
    websiteUrl: 'http://ptyc.net/',
    disabled: false,
  },
  {
    key: 'poulsbo yacht club',
    value: 'Poulsbo Yacht Club',
    flagUrl: poulsboYachtClubFlag,
    websiteUrl: 'http://poulsboyc.org/',
    disabled: false,
  },
  {
    key: 'puget sound yacht club',
    value: 'Puget Sound Yacht Club',
    flagUrl: pugetSoundYachtClubFlag,
    websiteUrl: 'http://www.pugetsoundyc.org/',
    disabled: false,
  },
  {
    key: 'quartermaster yacht club',
    value: 'Quartermaster Yacht Club',
    flagUrl: quartermasterYachtClubFlag,
    websiteUrl: 'http://www.qycv.org/',
    disabled: false,
  },
  {
    key: 'queen city yacht club',
    value: 'Queen City Yacht Club',
    flagUrl: queenCityYachtClubFlag,
    websiteUrl: 'https://www.queencity.org/reciprocal-visiting-boat',
    disabled: false,
  },
  {
    key: 'rainier yacht club',
    value: 'Rainier Yacht Club',
    flagUrl: rainierYachtClubFlag,
    websiteUrl: 'http://www.rainieryachtclub.com/',
    disabled: false,
  },
  {
    key: 'roche harbor yacht club',
    value: 'Roche Harbor Yacht Club',
    flagUrl: rocheHarborYachtClubFlag,
    websiteUrl: 'http://www.rhyc.org/',
    disabled: false,
  },
  {
    key: 'san juan island yacht club',
    value: 'San Juan Island Yacht Club',
    flagUrl: sanJuanIslandYachtClubFlag,
    websiteUrl: 'http://www.sjiyc.com/',
    disabled: false,
  },
  {
    key: 'seabacs yacht club (boeing co.)',
    value: 'Seabacs Yacht Club (Boeing Co.)',
    flagUrl: seabacsYachtClubBoeingCoFlag,
    websiteUrl: 'http://www.seabacs.com/',
    disabled: false,
  },
  {
    key: 'seattle singles yacht club',
    value: 'Seattle Singles Yacht Club',
    flagUrl: seattleSinglesYachtClubFlag,
    websiteUrl: 'http://www.seattlesinglesyc.com/',
    disabled: false,
  },
  {
    key: 'seattle yacht club',
    value: 'Seattle Yacht Club',
    flagUrl: seattleYachtClubFlag,
    websiteUrl: 'http://www.seattleyachtclub.org/',
    disabled: false,
  },
  {
    key: 'semiahmoo marina yacht club',
    value: 'Semiahmoo Marina Yacht Club',
    flagUrl: semiahmooMarinaYachtClubFlag,
    websiteUrl: 'https://semiahmoomarina.com/',
    disabled: false,
  },
  {
    key: 'semiahmoo yacht club',
    value: 'Semiahmoo Yacht Club',
    flagUrl: semiahmooYachtClubFlag,
    websiteUrl: 'http://www.semiahmooyachtclub.org/',
    disabled: false,
  },
  {
    key: 'sequim bay yacht club',
    value: 'Sequim Bay Yacht Club',
    flagUrl: sequimBayYachtClubFlag,
    websiteUrl: 'http://www.sequimbayyacht.club/',
    disabled: false,
  },
  {
    key: 'shelter bay yacht club',
    value: 'Shelter Bay Yacht Club',
    flagUrl: shelterBayYachtClubFlag,
    websiteUrl: 'http://shelterbayyachtclub.org/',
    disabled: false,
  },
  {
    key: 'shelton yacht club',
    value: 'Shelton Yacht Club',
    flagUrl: sheltonYachtClubFlag,
    websiteUrl: 'http://www.sheltonyachtclub.com/',
    disabled: false,
  },
  {
    key: 'shilshole bay yacht club',
    value: 'Shilshole Bay Yacht Club',
    flagUrl: shilsholeBayYachtClubFlag,
    websiteUrl: 'http://www.shilsholebayyachtclub.org/',
    disabled: false,
  },
  {
    key: 'sinclair inlet yacht club',
    value: 'Sinclair Inlet Yacht Club',
    flagUrl: sinclairInletYachtClubFlag,
    websiteUrl: 'http://sinclairinletyachtclub.org/',
    disabled: false,
  },
  {
    key: 'sloop tavern yacht club',
    value: 'Sloop Tavern Yacht Club',
    flagUrl: sloopTavernYachtClubFlag,
    websiteUrl: 'http://www.styc.org/',
    disabled: false,
  },
  {
    key: 'south sound sailing society',
    value: 'South Sound Sailing Society',
    flagUrl: southSoundSailingSocietyFlag,
    websiteUrl: 'http://www.ssssclub.com/',
    disabled: false,
  },
  {
    key: 'south whidbey yacht club',
    value: 'South Whidbey Yacht Club',
    flagUrl: southWhidbeyYachtClubFlag,
    websiteUrl: 'http://swyachtclub.org/',
    disabled: false,
  },
  {
    key: 'squalicum yacht club',
    value: 'Squalicum Yacht Club',
    flagUrl: squalicumYachtClubFlag,
    websiteUrl: 'http://www.squalicumyc.org/',
    disabled: false,
  },
  {
    key: 'swinomish yacht club',
    value: 'Swinomish Yacht Club',
    flagUrl: swinomishYachtClubFlag,
    websiteUrl: 'http://www.cruisesyc.org/',
    disabled: false,
  },
  {
    key: 'tacoma yacht club',
    value: 'Tacoma Yacht Club',
    flagUrl: tacomaYachtClubFlag,
    websiteUrl: 'http://www.tacomayachtclub.org/',
    disabled: false,
  },
  {
    key: 'three tree point yacht club',
    value: 'Three Tree Point Yacht Club',
    flagUrl: threeTreePointYachtClubFlag,
    websiteUrl: 'http://www.ttpyc.org/',
    disabled: false,
  },
  {
    key: 'totem yacht club',
    value: 'Totem Yacht Club',
    flagUrl: totemYachtClubFlag,
    websiteUrl: 'http://www.totemyachtclub.com/',
    disabled: false,
  },
  {
    key: 'tyee yacht club - seattle',
    value: 'Tyee Yacht Club - Seattle',
    flagUrl: tyeeYachtClubSeattleFlag,
    websiteUrl: 'http://www.tyeeyachtclub.org/',
    disabled: false,
  },
  {
    key: 'viking yacht club',
    value: 'Viking Yacht Club',
    flagUrl: vikingYachtClubFlag,
    websiteUrl: 'http://www.thevikingyachtclub.com/',
    disabled: false,
  },
  {
    key: 'washington yacht club',
    value: 'Washington Yacht Club',
    flagUrl: washingtonYachtClubFlag,
    websiteUrl: 'http://uwsail.org/',
    disabled: false,
  },
  {
    key: 'west seattle yacht club',
    value: 'West Seattle Yacht Club',
    flagUrl: westSeattleYachtClubFlag,
    websiteUrl: 'http://www.westseattleyachtclub.org/',
    disabled: false,
  },
  {
    key: 'west sound corinthian yacht club',
    value: 'West Sound Corinthian Yacht Club',
    flagUrl: westSoundCorinthianYachtClubFlag,
    websiteUrl: 'http://www.wscyc.net/',
    disabled: false,
  },
  {
    key: 'yakima valley boat club',
    value: 'Yakima Valley Boat Club',
    flagUrl: yakimaValleyBoatClubFlag,
    websiteUrl: 'https://yakimavalleyboat.club/',
    disabled: false,
  },
];

export const CHARITY_HOST = [
  {
    selectedOrganization: 'northwest-straits-foundation',
    foundationLogo: NorthwestStraitsFoundationLogo,
  },
  {
    selectedOrganization: 'puget-soundkeeper-alliance',
    foundationLogo: PugetSoundkeeperLogo,
  },
  {
    selectedOrganization: 'friends-of-the-san-juans',
    foundationLogo: FriendsSanJuansLogo,
  },
];

export const platformOffPercentage = 15;

export const MY_LISTINGS_TAB_TYPES = Object.freeze({
  LISTINGS: 'listings',
  REVIEW_RECEIVED: 'reviewsReceived',
  REVIEW_GIVEN: 'reviewsGiven',
  CHECK_INS: 'checkIns',
});

export const AMENITIES_OPTIONS = [
  { key: 'shoreAccess', label: 'Shore access nearby (specify in description)' },
  { key: 'restrooms', label: 'Restrooms' },
  { key: 'shorePower', label: 'Shore power (specify in description)' },
  { key: 'waterHookup', label: 'Water hookup' },
  { key: 'parkingOnShore', label: 'Parking on shore' },
  { key: 'eventSpace', label: 'Event space / Clubhouse' },
  { key: 'wifi', label: 'WiFi' },
  { key: 'pumpOut', label: 'Pump-out nearby' },
  { key: 'fuelDock', label: 'Fuel dock nearby' },
];
